import React, { useContext, useState } from "react";
import * as b from "./bootstrap.module.css";
import Icon from "../components/icon.tsx";
import useProducts from "../hooks/useProducts";
import Thumbnail from "./thumbnail";
import useMedia from "../hooks/useMedia";
import { Link } from "gatsby";
import Translate from "./translate";
import { ComparisionContext } from "./comparision-context";

const ProductComparisonBar = () => {
    const { comparisionItems, removeAllComparisionItems } = useContext(ComparisionContext);
    const { objectLists } = useProducts({ types: "all" });
    const [isOpen, setIsOpen] = useState(false);
    const isMobRes = useMedia(['(max-width: 992px)'], [true], false);

    if (!Object.values(comparisionItems).some(items => items.length >= 1)) {
        return null;
    }

    return (
        <aside
            className={`product-comparison-bar ${isOpen ? "open" : "closed"} ${isMobRes ? "has-mobile-toc" : ""}`}
        >
            <button onClick={() => setIsOpen(!isOpen)} className="toggler">
                {isOpen ? <Icon key="1" size={40} icon="Angle-down" /> : <Icon key="2" size={40} icon="Angle-up" />}
            </button>

            <div className={`${b.row} ${b.mx0} ${b.alignItemsCenter}`}>
                <div className={b.col}>
                    <div className={["product-comparison-flex",'scroll-inner'].join(' ')}>
                        {
                            Object.entries(comparisionItems).map(([comparisionKey, comparisionIds]) => {
                                const productArr = [];
                                comparisionKey.startsWith('firm') && productArr.push(...objectLists.firm);
                                comparisionKey.startsWith('account') && productArr.push(...objectLists.accounts);
                                comparisionKey.startsWith('credit') && productArr.push(...objectLists.credits);
                                comparisionKey.startsWith('card') && productArr.push(...objectLists.cards);

                                return productArr.map((product) => 
                                    comparisionIds.includes(product.mysqlId)
                                        ? (
                                            <div key={`product-${product.productType}-${product.mysqlId}`} className="product">
                                                <Thumbnail image={product.mysqlImage} />
                                            </div>
                                        )
                                        : null
                                );
                            })
                        }
                    </div>
                </div>

                <div className={`${b.colMdAuto} ${b.plMd0} ${b.mt2} ${b.mtLg0}`}>
                    <div className={`${b.row} ${b.noGutters} ${b.alignItemsCenter} ${b.justifyContentEnd}`}>
                        <div className={`${b.col5} ${b.colMdAuto} ${b.mbMd0} ${b.pr2} ${b.prMd3}`}>
                            <button
                                onClick={removeAllComparisionItems}
                                className={["product-comparison-btn", b.textCapitalize].join(" ")}
                            >
                                <Icon size={20} icon="Trash-bin" className={["icon-width", b.mr2].join(" ")} />
                                <Translate tKey="remove all" />
                            </button>
                        </div>
                        <div className={`${b.col7} ${b.colMdAuto}`}>
                            <Link
                                to="/porownywarka"
                                className={`product-comparison-btn product-comparison-btn-outline ${b.px5}`}
                            >
                                <Icon color="#fff" className={b.mr2} size={20} icon="PairOfScales" />
                                <Translate tKey="Compare" />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </aside>
    );
};

export default ProductComparisonBar;
